import React from 'react';
import { motion } from 'framer-motion';
import { useCountdown } from '../hooks/useCountdown';
import { Flame, ShieldCheck, ArrowRight, CreditCard, Banknote } from 'lucide-react';
const comparison = [{
  sin: 'Perfiles quemados',
  con: 'Cortes exactos'
}, {
  sin: '3 horas presupuestando',
  con: '15 minutos'
}, {
  sin: 'Clientes que desaparecen',
  con: 'Scripts que cierran'
}, {
  sin: 'No sabés si ganás',
  con: 'Tracker de margen real'
}];
export function UrgencySection() {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  return <section className="py-12 bg-matte text-white border-t-4 border-red-600" data-id="element-168">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-169">
        {/* Timer */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 mb-10 bg-red-600/10 border border-red-600/30 py-4 px-6 rounded-sm" data-id="element-170">
          <div className="flex items-center gap-2" data-id="element-171">
            <Flame className="w-6 h-6 text-red-500 animate-pulse" data-id="element-172" />
            <span className="font-black text-white uppercase tracking-wide text-lg" data-id="element-173">
              70% OFF termina en:
            </span>
          </div>
          <div className="flex items-center gap-1 font-mono" data-id="element-174">
            <div className="bg-red-600 px-3 py-1 text-2xl font-black min-w-[48px] text-center rounded-sm" data-id="element-175">
              {String(hours).padStart(2, '0')}
            </div>
            <span className="text-2xl font-black text-red-500" data-id="element-176">:</span>
            <div className="bg-red-600 px-3 py-1 text-2xl font-black min-w-[48px] text-center rounded-sm" data-id="element-177">
              {String(minutes).padStart(2, '0')}
            </div>
            <span className="text-2xl font-black text-red-500" data-id="element-178">:</span>
            <div className="bg-red-600 px-3 py-1 text-2xl font-black min-w-[48px] text-center rounded-sm" data-id="element-179">
              {String(seconds).padStart(2, '0')}
            </div>
          </div>
        </div>

        {/* Guarantee */}
        <motion.div initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="flex items-start gap-4 bg-white/5 p-5 border border-silver/10 mb-10" data-id="element-180">
          <ShieldCheck className="w-8 h-8 text-gold flex-shrink-0 mt-1" data-id="element-181" />
          <p className="text-base md:text-lg font-medium text-silver leading-snug" data-id="element-182">
            <strong className="text-white" data-id="element-183">7 días de garantía.</strong> Si no te
            sirve, te devolvemos el 100% sin preguntas. Un WhatsApp alcanza.
          </p>
        </motion.div>

        {/* Comparison */}
        <div className="max-w-2xl mx-auto mb-10" data-id="element-184">
          <div className="grid grid-cols-2 text-center mb-2" data-id="element-185">
            <div className="font-bold text-red-400 uppercase text-xs tracking-wider" data-id="element-186">
              Sin sistema
            </div>
            <div className="font-bold text-green-400 uppercase text-xs tracking-wider" data-id="element-187">
              Con sistema
            </div>
          </div>
          <div className="space-y-1" data-id="element-188">
            {comparison.map((row, i) => <div key={i} className="grid grid-cols-2 bg-white/5 border-b border-white/5 last:border-0" data-id="element-189">
                <div className="p-3 text-sm text-gray-400 text-right border-r border-white/5" data-id="element-190">
                  {row.sin}
                </div>
                <div className="p-3 text-sm font-bold text-white text-left" data-id="element-191">
                  {row.con}
                </div>
              </div>)}
          </div>
        </div>

        <div className="text-center mb-8" data-id="element-192">
          <p className="text-xl md:text-2xl font-black text-white leading-tight" data-id="element-193">
            La carpintería de aluminio tiene demanda todos los días.
            <br data-id="element-194" />
            <span className="text-gold" data-id="element-195">
              La pregunta es si vas a estar preparado.
            </span>
          </p>
        </div>

        {/* Final CTAs */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-8" data-id="element-196">
          <a href="https://solucionstore.shop/cart/45494138568895:1" target="_blank" rel="noopener noreferrer" className="w-full sm:w-auto bg-steel text-white font-bold text-base px-8 py-4 text-center hover:bg-steel/90 transition-colors uppercase" data-id="element-197">
            Opción 1 — $19.990 →
          </a>
          <a href="https://solucionstore.shop/cart/45494160785599:1" target="_blank" rel="noopener noreferrer" className="w-full sm:w-auto bg-gold text-matte font-black text-lg px-8 py-4 text-center shadow-[0_0_20px_rgba(212,160,23,0.3)] hover:bg-yellow-500 transition-colors uppercase" data-id="element-198">
            Opción 2 — $27.990 →
          </a>
        </div>

        <div className="flex flex-wrap justify-center gap-4 text-xs text-gray-500 font-bold uppercase tracking-wider pb-6 border-b border-white/10" data-id="element-199">
          <span className="flex items-center" data-id="element-200">
            <CreditCard className="w-4 h-4 mr-1.5" data-id="element-201" /> Mercado Pago
          </span>
          <span className="flex items-center" data-id="element-202">
            <CreditCard className="w-4 h-4 mr-1.5" data-id="element-203" /> Tarjeta
          </span>
          <span className="flex items-center" data-id="element-204">
            <Banknote className="w-4 h-4 mr-1.5" data-id="element-205" /> Transferencia
          </span>
        </div>

        <div className="text-center text-xs text-gray-600 mt-6 font-medium" data-id="element-206">
          © Super Combo Carpintería en Aluminio PRO 2026 — Argentina
        </div>
      </div>
    </section>;
}